import {
  useState,
  useMemo,
  useContext,
  useEffect,
  createContext,
  useRef,
} from "react";
import { AgGridReact } from "ag-grid-react";
import {
  AllCommunityModule,
  ModuleRegistry,
  themeQuartz,
} from "ag-grid-community";
import BtnActionUpdateDeleteUser from "./sub-componentes/dashboard/BtnActionUpdateDeleteUser";
import { listTypeUsers } from "../global/GlobalVariables";
import { EmailPopUp } from "./sub-componentes/dashboard/EmailPopUp";
import { Context } from "../App";
import { getUsers, getPlans } from "../api/admin/adminServices";
import LoadingPage from "./LoadingPage";
import ModalAlertLoading from "./ModalAlertLoading";
import { useNavigate } from "react-router-dom";
import { invertPlanName } from "./functions/Dashboard";
import ModalConfirm from "./ModalConfirm";
export const ContextAdmin = createContext();

ModuleRegistry.registerModules([AllCommunityModule]);

const myDarkTheme = themeQuartz.withParams({
  backgroundColor: "#1f2836",
  browserColorScheme: "dark",
  chromeBackgroundColor: {
    ref: "foregroundColor",
    mix: 0.07,
    onto: "backgroundColor",
  },
  fontFamily: "inherit",
  fontSize: 16,
  foregroundColor: "#FFF",
  headerFontSize: 16,
  spacing: 8,
  wrapperBorderRadius: 10,
});

const myLightTheme = themeQuartz.withParams({
  browserColorScheme: "light",
  fontFamily: "inherit",
  headerFontSize: 16,
});

function DashboardUsers() {
  const navigate = useNavigate();

  const { statusMode } = useContext(Context);
  const [rowData, setRowData] = useState([]);
  const [canShowUsers, setCanShowUsers] = useState(false);
  const dataUsersJson = useRef(JSON.stringify({}));
  const [messageModal, setMessageModal] = useState("");
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [listPlans, setListPlans] = useState([]);
  const infoPlans = useRef({});
  const listNamePlansToShow = useRef({});
  const [iconToShow, setIconToShow] = useState("");
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const functionStorage = useRef(function(){});

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 150,
      filter: true,
      floatingFilter: true,
      editable: true,
    };
  }, []);

  const columnDefs = [
    {
      field: "email",
      editable: false,
      cellRenderer: EmailPopUp,
    },
    { field: "phone", headerName: "Telefone", editable: false },

    {
      headerName: "Tipo de Conta",
      field: "username",
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: listTypeUsers,
      },
    },
    {
      headerName: "Planos",
      field: "tipo_de_plano",
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: listPlans,
      },
    },
    {
      field: "data_expiracao",
      headerName: "Data de Expiração",
      cellDataType: "date",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString("pt-BR");
      },
    },
    {
      field: "status_da_conta",
      headerName: "Status da Conta",
      editable: false,
    },
    { field: "cuponuser", headerName: "Cupon", editable: false },
    {
      colId: "actions",
      headerName: "Ações",
      cellRenderer: BtnActionUpdateDeleteUser,
      editable: false,
    },
  ];

  const onCellValueChanged = (params) => {
    const { data, colDef, node } = params;

    if (colDef.field === "tipo_de_plano") {
      
      let daysPlan = infoPlans.current[data.tipo_de_plano]["days"];
      daysPlan = daysPlan < 0 ? 0 : daysPlan;
      let nowDateTime = new Date();

      nowDateTime.setDate(nowDateTime.getDate() + daysPlan);

      data.data_expiracao = nowDateTime;

      node.setDataValue("data_expiracao", data.data_expiracao);
    }
  };

  

  function getUserDataToTable(canUpdateMessageModal = false) {
    if (canUpdateMessageModal === true) {
      setMessageModal(
        "Aguarde enquanto carregamos a nova lista de usuários atualizada."
      );
    }

    const plansNamesInverted = invertPlanName(listNamePlansToShow);

    getUsers().then((data) => {
      let newUsersValue = data["value"].map((item) => {
        let xxx =
          item["data_expiracao"] === null
            ? item["data_cadastro"].toString()
            : item["data_expiracao"].toString();
        item["data_expiracao"] = new Date( (xxx + "T00:00:00") );

        item["tipo_de_plano"] = plansNamesInverted[item["tipo_de_plano"]];

        return item;
      });

      dataUsersJson.current = JSON.stringify(newUsersValue);
      setRowData(newUsersValue);
      setCanShowUsers(true);
      if (canUpdateMessageModal === true) {
        setMessageModal("Lista de usuários carregada com sucesso!");
        setIconToShow("success");
      }
    });
  }

  useEffect(() => {
    getPlans().then((data) => {
      let plans = data["value"];
      let listPlans = [];
      let newListNamePlansToShow = {};
      let newInfoPlans = {};
      for (let i = 0; i < plans.length; i++) {
        let item = plans[i];

        if (newListNamePlansToShow[item["short_name"]] === undefined) {
          newListNamePlansToShow[item["short_name"]] = [];
          newInfoPlans[item["short_name"]] = item;
          listPlans.push(item["short_name"]);
        }
        newListNamePlansToShow[item["short_name"]].push(item["name"]);
      }

      setListPlans(listPlans);
      infoPlans.current = newInfoPlans;
      listNamePlansToShow.current = newListNamePlansToShow;
      getUserDataToTable();
    });
  }, []);

  return (
    <>
      <ModalAlertLoading
        messageModal={messageModal}
        show={showModalMessage}
        setShow={setShowModalMessage}
        iconToShow={iconToShow}
      />

      <ModalConfirm
        messageModal={messageModal}
        show={showModalConfirm}
        setShow={setShowModalConfirm}
        functionStorage={functionStorage}
      />

      {canShowUsers === true ? (
        <>
          <style>
            {`
            body{
                ${
                  statusMode
                    ? "background-color: #16171b!important;"
                    : "background-color: #fdfafe!important;"
                }
                min-height: 130vh;
            }
            `}
          </style>
          <div className="position-relative mb-5">
            <div id="dashboard-bg-container"></div>

            <div id="dashboard-container-users">
              <div
                id="dashboard-users"
                className={`${statusMode ? "dark-mode" : "light-mode"}`}
              >
                <div className="w-100 p-5 m-3 pb-4">
                  <div className="w-100 d-flex d-flex justify-content-between align-items-center">
                    <h1
                      id="dashboard-title"
                      className={`${statusMode ? "text-light" : ""}`}
                    >
                      Usuários
                    </h1>
                    <button
                      className="btn btn-primary style-height-fit-content"
                      onClick={() => {
                        navigate("/dashboard");
                      }}
                    >
                      voltar
                    </button>{" "}
                  </div>
                  <div style={{ width: "100%" }}>
                    <ContextAdmin.Provider
                      value={{
                        dataUsersJson,
                        getUserDataToTable,
                        setMessageModal,
                        setShowModalMessage,
                        setIconToShow,
                        listNamePlansToShow,
                        functionStorage,
                        setShowModalConfirm,
                      }}
                    >
                      <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        pagination={true}
                        paginationPageSize={20}
                        theme={statusMode ? myDarkTheme : myLightTheme}
                        defaultColDef={defaultColDef}
                        onCellValueChanged={onCellValueChanged}
                        alwaysMultiSort={true}
                        domLayout="autoHeight"
                      />
                    </ContextAdmin.Provider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <LoadingPage />
      )}
    </>
  );
}

export default DashboardUsers;
